import { configureStore } from '@reduxjs/toolkit';
import authSlice from './authSlice';
import fenceOptionsSlice from './fenceOptionsSlice';
import calculationsSlice from './calculationsSlice';
import bracketOptionsSlice from './bracketOptionsSlice';
import { enableMapSet } from '../../node_modules/immer/dist/immer';

// allows maniplation of immutable like Map
enableMapSet();

export const store = configureStore({
  reducer: {
    auth: authSlice,
    fenceOptions: fenceOptionsSlice,

    calculations: calculationsSlice,
    bracketOptions: bracketOptionsSlice
  }
});
